import script from "./WritingPractice.vue?vue&type=script&setup=true&lang=js"
export * from "./WritingPractice.vue?vue&type=script&setup=true&lang=js"

import "./WritingPractice.vue?vue&type=style&index=0&id=46f2dd9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f2dd9c"]])

export default __exports__